import moment from '@/moment-gp.js'
import util from '@/util'
import Color from 'color'
import $models from '@/models'
import api from '@/api'

/*
 * This uses ISO 8601 definition for week 01
 * https://en.wikipedia.org/wiki/ISO_week_date#First_week
 * instead of the simple week definition:
 * http://www.proesite.com/timex/wkcalc.htm
 */

 // ['YYYY-MM-DD']
 // TODO: Don't return anything before everything is ready

export default {
  /*
   */
  is_ready: state => state.initial_data_ready,

  /*
   */
  is_dragging: state => state.is_dragging,

  /*
   */
  current_drop_zone: state => state.current_drop_zone,

  /*
  */
  calendar_source_view_settings: state => state.calendar_view_settings.source,

  /*
  */
  calendar_view_settings: state => {

    // TODO: Alternatively do a deep clone and transform dates
    let view_settings = {
      view: state.calendar_view_settings.view,
      timeslotDuration: state.calendar_view_settings.timeslotDuration,
      show_now_indicator: state.calendar_view_settings.show_now_indicator,
      visible_range: {
        from_date: moment.fromStore( state.calendar_view_settings.visible_range.from_date ),
        to_date:   moment.fromStore( state.calendar_view_settings.visible_range.to_date ),
        horizon:   state.calendar_view_settings.visible_range.horizon
      },
      visible_time: {
        min_time: state.calendar_view_settings.visible_time.min_time,
        max_time: state.calendar_view_settings.visible_time.max_time
      }
    }
    return view_settings;
  },

  /*
  */
  get_view_range_start: (state, getters) =>  {
    return getters.calendar_view_settings.visible_range.from_date;
  },

  /*
  Returns currently selected timeslot collection / effort / goal
  */
  get_tsc_selected: state => state.timeslot_collection_selected,
  get_effort_selected: state => state.effort_selected,
  get_goal_selected: state => state.goal_selected,

  // --------------------------------------------------------------------------

  /*
  */
  user_timeline_events: (state, getters, rootState, rootGetters) => {

    return [];

    // TODO
    // TODO
    // TODO
    // TODO
    // TODO

    /*
    let all_events_this_week = getters.calendar_all_events;

    let timeslot_collection_colorsArray = []
    let timeslot_collection_list = $models.timeslotCollection.getList().itemsAsArray();
    timeslot_collection_list.forEach((timeslot_collection) => {
      timeslot_collection_colorsArray[timeslot_collection.$id] = timeslot_collection.color
    })
    let items = all_events_this_week.map(event => {

      let color;
      if ( event.tscId ) {
        if ( event.tscId === '<new>') {
          console.warn("<new> not implemented");
          color = "pink";
        } else {
          let timeslotCollection = timeslot_collection_colorsArray[event.tscId];
          color = Color(timeslotCollection.color);
        }
      } else {
        color = Color("#000000");
      }

      return {
        id:     event.id,
        title:  event.cachedName, // TODO
        start:  event.userStart.toFullCalendarV3(),
        end:    event.userEnd.toFullCalendarV3(),
        color:  color,
        className: 'fc-session',
        data: {
          tscId:          event.tscId || null,
          goalId:         event.goalId || null,
          commitmentId:   event.commitmentId || null,
          seqItemId:      event.seqItemId || null,
          source:         event.originIsOptimizer ? 'OPTIMIZER-LOCKED' : 'USER',
        }
      }
    }).filter(event => event)
    return items;
    */
  },

  optimizer_timeline_events(state, getters, rootState, rootGetters) {

    let all_commitments = api.get_ready('commitments')
    if (all_commitments) {
      // let commitment_list_all = rootGetters["goal/commitment_list_all"]
      let commitment_list_all = $models.commitment.getters.commitment_list_all;
      // console.log("[optimizer_timeline_events] commitment_list_all", commitment_list_all);

      let effort_by_effort_idArray = []
      commitment_list_all.forEach((effort) => {
        effort_by_effort_idArray[effort.commitmentId] = effort
      })
      // console.log("[optimizer_timeline_events] effort_by_effort_idArray", effort_by_effort_idArray);

      let timeslot_collection_colorsArray = []
      let timeslot_collection_list = $models.timeslotCollection.getList().itemsAsArray();
      //console.log('marker 1 timeslot_collection_list', clonedeep(timeslot_collection_list))
      timeslot_collection_list.forEach((timeslot_collection) => {
        timeslot_collection_colorsArray[timeslot_collection.$id] = timeslot_collection.color
      })
      // console.log("[optimizer_timeline_events] timeslot_collection_colorsArray", timeslot_collection_colorsArray);

      let eventlist_calendar = rootGetters["optimizer/masked_optimizer_results"].map((item) => {

        // console.log("[optimizer_timeline_events] item", item);
        let commitment = effort_by_effort_idArray[ item.commitmentId ] // TODO "commitment"
        if ( !commitment ) {
          return null
        }

        let tsc_id = commitment.user.timeslotCollectionId;
        let color  = Color( tsc_id ? timeslot_collection_colorsArray[ tsc_id ] : "#000000" );
        return {
          type:       item.type,
          source:     item.source,
          commitmentSessionId:  item.commitmentSessionId,
          id:         item.pseudoId,
          title:      commitment.meta.name,
          // start:    item.day + 'T' + (item.start.length === 4 ? '0' : '') + item.start + ':00',
          // end:      item.day + 'T' + (item.end.length === 4 ? '0' : '') + item.end + ':00',
          // start:    moment.unix( item.start ).tz(this.user_get_timezone),
          // end:      moment.unix( item.end ).tz(this.user_get_timezone),
          start:      item.start, // toFullCalendarV3?
          end:        item.end,
          allDay:     false,
          color:      Color(color).fade(0.33),
          className:  'fc-session-optimizer',
          tasks:      item.tasks || null,
          sequenceItems:  item.sequenceItems || null,
          data: {
            commitmentId:   item.commitmentId || null, // TODO "commitment"
            tscId:          tsc_id || null,
            goalId:         commitment.goalId || null,
            source:         'OPTIMIZER',
          },
        };
      }).filter(event => event);

      //console.log("[optimizer_timeline_events] eventlist_calendar", eventlist_calendar);
      return eventlist_calendar.sort(util.sorter.by_start)
    } else {
      return []
    }
  },

  flattened_timeslots(state, getters, rootState, rootGetters) { // TODO -> tsc_events
    let eventlist_calendar = [];
    let timeslot_collection_list = $models.timeslotCollection.getList().itemsAsArray();

    timeslot_collection_list.map((timeslot_collection) => {
      // TODO: Worker
      let flattened_calendar_data = rootGetters["timeslots/flattened_calendar_data_all"][timeslot_collection.$id];

      flattened_calendar_data.event_data.map((data) => {

        let eventColor = data.exception ? timeslot_collection.color : Color(timeslot_collection.color).fade(0.33)
        eventColor = data.deleted ? 'rgba(0,0,0,0.25)' : eventColor;

        /*
        rendering               Sets every Event Object's rendering for this source.
        overlap                 Sets every Event Object's overlap for this source.
        */

        // TODO: Check if we need to convert the moment object here

        eventlist_calendar.push({
          title:  timeslot_collection.name + ( data.deleted ? '\nDELETED' : ''),
          start:  data.from, // toFullCalendarV3?
          end:    data.to,
          devStart: data.from.format(),
          devEnd: data.to.format(),
          allDay: false,
          color:  eventColor,
          className: 'fc-timeslot' + ( data.deleted ? ' fc-deleted' : ''),
          data: {
            source: 'TSC',
            ...data,
            tscId: timeslot_collection.$id
          }
        });
      });
    });
    return eventlist_calendar;
  },
}
